// LastAddedBanner — Presentational confirmation banner shown after a flight has
// been added to the trip, prompting the user to look up a connecting leg (the
// departure airport is pre-filled for them by the container).
//
// Extracted verbatim from `FlightLookup.js` as part of the behavior-preserving
// refactor (issue #240). Render-only, wrapped in React.memo. Preserves the
// source's `if (!lastAddedFlight) return null;` render guard and identical
// markup/styles/text.
//
// Props:
//   lastAddedFlight - the most recently added flight object; when falsy the
//                     component renders nothing
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const LastAddedBanner = React.memo(function LastAddedBanner({ lastAddedFlight }) {
  if (!lastAddedFlight) return null;
  return (
    <div style={{
      padding: '10px 14px',
      backgroundColor: '#f0fdf4',
      border: '1px solid #86efac',
      borderRadius: '8px',
      marginBottom: '16px',
      fontSize: '13px',
      color: '#15803d'
    }}>
      <strong>{lastAddedFlight.airline}{lastAddedFlight.flightNumber}</strong> added ({lastAddedFlight.departureAirport} → {lastAddedFlight.arrivalAirport}).
      {' '}Connecting flight? Look up your next leg below — departure airport is pre-filled.
    </div>
  );
});

export default LastAddedBanner;
